module.exports = __webpack_public_path__ + "8746057d014be5e372764d6b6e8a927d.svg";